/*
 * This pattern match this format:
 * +31636363634
 * */
// const pattern = /^\+[1-9]\d{7,14}$/;

/*
 * This pattern match these format:
 * 123-456-7890
 * 123.456.7890
 * 1234567890
 * +31636363634
 * 075-63546725
 * 075-734 9721
 * 075 734 9721
 * */
const newPattern = /^[+]?[0-9]{3}[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

export function isValidPhone(phone: string) {
    return newPattern.test(phone);
}
